<template>
    <form
      autocomplete="off"
      @submit.prevent="next('stepContent2', 'dadosDependentes')"
      data-vv-scope="stepContent2"
    >
      <div class="row">
        <div class="col">
          <h4>Endereço</h4>
        </div>
      </div>
      <hr />
      <div class="form-row">
        <div class="form-group col-md-4">
          <div class="form-group" :class="{'has-danger': errors.has('stepContent2.cep')}">
            <label for="celular">CEP</label>
            <input
              autofocus
              type="tel"
              name="cep"
              id="cep"
              @keyup="buscaCEP()"
              v-model="payload.cep"
              v-validate="'required'"
              v-mask="'#####-###'"
              class="form-control"
              aria-describedby="helpId"
            />
            <div
              v-if="errors.has('stepContent2.cep')"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first('stepContent2.cep')}}</div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-9">
          <div class="form-group" :class="{'has-danger': errors.has('stepContent2.endereco')}">
            <label for="endereco">Endereço</label>
            <input
              type="text"
              name="endereco"
              id="endereco"
              v-model="payload.enderecoResidencial"
              v-validate="'required'"
              class="form-control"
              aria-describedby="helpId"
            />
            <div
              v-if="errors.has('stepContent2.endereco')"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first('stepContent2.endereco')}}</div>
          </div>
        </div>
        <div class="form-group col-md-3">
          <div class="form-group" :class="{'has-danger': errors.has('stepContent2.nrEndereco')}">
            <label for="celular">Número</label>
            <input
              type="tel"
              name="nrEndereco"
              id="nrEndereco"
              v-model="payload.enderecoNumero"
              v-validate="'required'"
              class="form-control"
              aria-describedby="helpId"
            />
            <div
              v-if="errors.has('stepContent2.nrEndereco')"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first('stepContent2.nrEndereco')}}</div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <div class="form-group" :class="{'has-danger': errors.has('stepContent2.complemento')}">
            <label for="complemento">Complemento</label>
            <input
              type="text"
              name="complemento"
              id="complemento"
              v-model="payload.endereComplemento"
              class="form-control"
              aria-describedby="helpId"
            />
            <div
              v-if="errors.has('stepContent2.complemento')"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first('stepContent2.complemento')}}</div>
          </div>
        </div>
        <div class="form-group col-md-4">
          <div class="form-group" :class="{'has-danger': errors.has('stepContent2.bairro')}">
            <label for="bairro">Bairro</label>
            <input
              type="text"
              name="bairro"
              id="bairro"
              v-model="payload.bairro"
              v-validate="'required'"
              class="form-control"
              aria-describedby="helpId"
            />
            <div
              v-if="errors.has('stepContent2.bairro')"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first('stepContent2.bairro')}}</div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <div class="form-group" :class="{'has-danger': errors.has('stepContent2.cidade')}">
            <label for="cidade">Cidade</label>
            <input
              type="text"
              name="cidade"
              id="cidade"
              v-model="payload.cidade"
              v-validate="'required'"
              class="form-control"
              aria-describedby="helpId"
            />
            <div
              v-if="errors.has('stepContent2.cidade')"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first('stepContent2.cidade')}}</div>
          </div>
        </div>
        <div class="form-group col-md-2">
          <div class="form-group" :class="{'has-danger': errors.has('stepContent2.ufEndereco')}">
            <label for="ufEndereco">UF</label>
            <select
              name="ufEndereco"
              class="form-control"
              id="ufEndereco"
              v-validate="'required'"
              v-model="payload.uf"
            >
              <option :value="null">Selecione</option>
              <option v-for="uf in ufs" :key="uf" :value="uf" v-text="uf" />
            </select>
            <div
              v-if="errors.has('stepContent2.ufEndereco')"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first('stepContent2.ufEndereco')}}</div>
          </div>
        </div>
      </div>
      <div class="form-buttons-w text-right">
        <button class="btn btn-primary step-trigger-btn" @click="$store.dispatch('setStep', 'dadosTitular')">Voltar</button>
        <button class="btn btn-primary step-trigger-btn">Continuar</button>
      </div>
    </form>
</template>
<script>
import ufs from '@/utils/ufs';

import http from 'axios';

export default {
    props: {
        payload: {
            type: Object,
            required: true
        }
    },
    computed: {
        step() {
            return this.$store.getters.step;
        },
        empresa() {
            return this.$store.getters.empresa;
        },
        ufs() {
          return ufs;
        }
    },
    methods: {
        buscaCEP() {
            if (this.payload.cep) {
                this.payload.cep = this.payload.cep.replace(/[-]/g, "");
                if (this.payload.cep.length === 8) {
                http
                    .get(`https://viacep.com.br/ws/${this.payload.cep}/json/`)
                    .then(result => {
                        let endereco = result.data;
                        this.payload.cidade = endereco.localidade;
                        this.payload.bairro = endereco.bairro;
                        this.payload.enderecoResidencial = endereco.logradouro;
                        this.payload.uf = endereco.uf;
                        this.payload.endereComplemento = endereco.complemento;
                    });
                }
            }
        },
        next(from, to) {
            this.$validator.validateAll(from).then(result => {
                if (result) {
                    this.$store.dispatch('setStep', to);
                }
            });
        }
    }
}
</script>